module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT///9gns7z+PuFtdqdxOG20umRvN14rdbn8PgI0In9AAAACHRSTlMAYL//ACDP71kzCuAAAAEUSURBVHgB7djBsoMgDIXhKGrxCKK+/8Nes7wpFsTIin/ZxTfjGCkT4rrePKjvhjMahnEyD5tGhsaPedxnPKHJKDQN1BmVOup1oJ6MUg1qUFkNsrOJNNs0JB2YSJBSCloc4hDckoKkE4dYyoe8wzUE53MhD1xDnM+DVqQgrDlQQBpCSEI2IAdCsL8hOyMP+hookk5uUiIxPtnJgSLplEokx/CW5GOQR0H+G1pR1CqhgMLCP8jed8RoMsQ9gd54NG5DUdtbr5/b7w/k/uonwtKBGx2L1jFS4WDjco/aWoc/t6Whre4fJI/mL8jt9S8RPJpX0LHUu2hJySZ/rH+rbVCDGqS2ZFFb+2gtotRWY5rLujON9eEf8QNcVx1wVF8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2194.png
// module id = 1316
// module chunks = 0